<article class="chart">
  <header class="chart__heading">
    <h2 class="chart__title">{{ vm?.title }}</h2>
    <p class="chart__subtitle">{{ vm?.subtitle }}</p>
  </header>
  <div class="chart__body">
    <ng-container *ngIf="!vm?.isEmpty; else empty">
      <div class="chart__canvas">
        <ifc-bar-chart [data]="vm?.data" [options]="vm?.options"></ifc-bar-chart>
      </div>
      <ul class="chart__legend">
        <li class="chart__legend-item" *ngFor="let item of vm?.legend; trackBy: trackBySeries">
          <span class="chart__legend-swatch" [attr.data-series]="item.series" aria-hidden="true"></span>
          <span class="chart__legend-label">{{ item.label }}</span>
        </li>
      </ul>
    </ng-container>
    <ng-template #empty>
      <p class="chart__empty">{{ vm?.emptyMessage }}</p>
    </ng-template>
  </div>
</article>
